import Country from '~/Api/Country/Country';

export default class ReferenceBasketVersion {
	id: string;
	name: string;
	description: string;
	sinceDate: Date | null;
	order: number;
	referencedCountry?: Country;
	referenceCountries?: Country[];

	constructor(
		id: string,
		name: string,
		description: string,
		sinceDate: Date | null,
		order: number,
		referencedCountry: Country,
		referenceCountries: Country[]
	) {
		this.id = id;
		this.name = name;
		this.description = description;
		this.sinceDate = sinceDate;
		this.order = order;
		this.referencedCountry = referencedCountry;
		this.referenceCountries = referenceCountries;
	}
}
